import React, { useEffect } from "react";
import { Button, Chip, TextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import { Autocomplete } from "@material-ui/lab";
import SelectMenu from "../Utility/SelectMenu";
import RenderDatePicker from "../Utility/RenderDatePicker";
import "../style.css";
import { DropdownDateRangePicker } from "../Utility/SelectDateRange";
const ViewFilter = (props) => {
  
  // useEffect(() => {
  //   console.log("View Filter props.dateRange:", props.dateRange);
  //   console.log(
  //     "View Filter props.selectedFromDateRP:",
  //     props.selectedFromDateRP
  //   );
  //   console.log("View Filter props.selectedToDateRP:", props.selectedToDateRP);
  // }, [props.dateRange]);

  return (
    <>
      <>
        <div class="filter-main-div">
          <div className="gstr2a2bnew-datepicker-container">
            <RenderDatePicker
              flag={"multipleMonths"}
              selectedFromDateRP={props.selectedFromDateRP}
              selectedToDateRP={props.selectedToDateRP}
              setSelectedToDateRP={props.setSelectedToDateRP}
              setSelectedFromDateRP={props.setSelectedFromDateRP}
            />
          </div>
          <div>
            <label
              style={{
                fontFamily: "GT-Walsheim-medium",
                fontSize: "12px",
                // marginBottom: "2px",
              }}
            >
              Select Invoice Date
            </label>
            <DropdownDateRangePicker
              initialStartDate={props.selectedFromDateRP}
              initialEndDate={props.selectedToDateRP}
              minDate={props.selectedFromDateRP}
              maxDate={props.selectedToDateRP}
              width={"215px"}
              setDateRange={props.setDateRange}
              dateRange={props.dateRange}
              selection={true}
            />
          </div>
        </div>

        <div className="filter-chips-background">
          <div style={{ display: "flex" }}>
            <div className="filter-chips-heading">Taxpayer GSTIN</div>
            <div className="filter-chips-background-div">
              {props.gstinTaxpayerFilter.map((gstin, i) => (
                <Chip
                  className="filter-chips"
                  label={gstin}
                  clickable
                  color="primary"
                  onDelete={() => {
                    props.handleChipDelete(i, "gstin");
                  }}
                />
              ))}
            </div>
          </div>
          <div style={{ display: "flex" }} className="filter-text-input">
            <FormControl fullWidth variant="filled" style={{ width: "40%" }}>
              <label for="filled-adornment-amount" className="filter-label">
                Taxpayer GSTIN
              </label>

              <Autocomplete
                {...props.defaultPropsTaxGstins}
                id="auto-complete"
                value={props.taxpayerGstin}
                onChange={(event, newValue) => {
                  props.onChangeTaxpayerGstin(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    //margin="normal"
                    style={{ backgroundColor: "#eaeaea" }}
                  />
                )}
              />
            </FormControl>
            <Button
              onClick={props.handleAddTaxpayerGstin}
              className="filter-add-button"
            >
              + Add
            </Button>
          </div>
        </div>

        <div className="filter-chips-background">
          <div style={{ display: "flex" }}>
            <div className="filter-chips-heading">
              GSTIN/ UIN of counterparty
            </div>
            <div className="filter-chips-background-div">
              {props.ctinTaxpayerFilter.map((ctin, i) => (
                <Chip
                  className="filter-chips"
                  label={ctin}
                  clickable
                  color="primary"
                  onDelete={() => {
                    props.handleChipDelete(i, "ctin");
                  }}
                />
              ))}
            </div>
          </div>
          <div style={{ display: "flex" }} className="filter-text-input">
            <FormControl fullWidth variant="filled" style={{ width: "40%" }}>
              <label for="filled-adornment-amount" className="filter-label">
                GSTIN/ UIN of counterparty
              </label>

              <Autocomplete
                {...props.defaultPropsCounterPartyGstins}
                id="auto-complete"
                value={props.counterpartyGstin}
                onChange={(event, newValue) => {
                  props.onChangeCounterpartyGstin(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    //margin="normal"
                    style={{ backgroundColor: "#eaeaea" }}
                  />
                )}
              />
            </FormControl>
            <Button
              onClick={props.handleAddCounterpartyGstin}
              className="filter-add-button"
            >
              + Add
            </Button>
          </div>
        </div>

        <div className="filter-chips-background">
          <div style={{ display: "flex" }}>
            <div className="filter-chips-heading">Invoice Number</div>
            <div className="filter-chips-background-div">
              {props.inumFilter.map((inum, i) => (
                <Chip
                  className="filter-chips"
                  label={inum}
                  clickable
                  color="primary"
                  onDelete={() => {
                    props.handleChipDelete(i, "Inum");
                  }}
                />
              ))}
            </div>
          </div>
          <div style={{ display: "flex" }} className="filter-text-input">
            <FormControl fullWidth variant="filled" style={{ width: "40%" }}>
              <label for="filled-adornment-amount" className="filter-label">
                Invoice Number
              </label>

              <Autocomplete
                {...props.defaultPropsInum}
                id="auto-complete"
                value={props.inum}
                onChange={(event, newValue) => {
                  props.onChangeInum(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    //margin="normal"
                    style={{ backgroundColor: "#eaeaea" }}
                  />
                )}
              />
            </FormControl>
            <Button onClick={props.handleAddInum} className="filter-add-button">
              + Add
            </Button>
          </div>
        </div>

        {props?.showDocInv && (<>
        <div className="filter-chips-background ">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="filter-dropdown-label">Doc Type</div>
            <div className="filter-dropdown-label">Invoice Type</div>
          </div>
          <div
            style={{ display: "flex", justifyContent: "space-between" }}
            className="filter-text-input"
          >
            <div
              className="dropdown-container-gstr2a2bnew document-type-filter"
              style={{ width: "40%" }}
            >
              <SelectMenu
                options={props.docTypeList}
                selectedValue={props.docTypeFilter}
                handleChange={(e) => props.handleDocTypeFilterChange(e)}
              />
            </div>
            <div
              className="dropdown-container-gstr2a2bnew document-type-filter"
              style={{ width: "40%" }}
            >
              <SelectMenu
                options={props.invoiceTypeList}
                selectedValue={props.invoiceTypeFilter}
                handleChange={(e) => props.handleInvoiceTypeFilterChange(e)}
              />
            </div>
          </div>
        </div>
        </>)}
        <div className="filter-chips-background ">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="filter-dropdown-label">Doc Status</div>
            <div className="filter-dropdown-label">Reco Status</div>
          </div>
          <div
            style={{ display: "flex", justifyContent: "space-between" }}
            className="filter-text-input"
          >
            <div
              className="dropdown-container-gstr2a2bnew document-type-filter"
              style={{ width: "40%" }}
            >
              <SelectMenu
                options={props.docStatusList}
                selectedValue={props.docStatusFilter}
                handleChange={(e) => props.handleDocStatusFilterChange(e)}
              />
            </div>
            <div
              className="dropdown-container-gstr2a2bnew document-type-filter"
              style={{ width: "40%" }}
            >
              <SelectMenu
                options={props.recoStatusList}
                selectedValue={props.recoStatusFilter}
                handleChange={(e) => props.handleRecoStatusFilterChange(e)}
              />
            </div>
          </div>
        </div>
        {props.flag === "FetchViewTab" && (
          <>
            <div className="filter-chips-background ">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="filter-dropdown-label">Data Type</div>
              </div>
              <div
                style={{ display: "flex", justifyContent: "space-between" }}
                className="filter-text-input"
              >
                <div
                  className="dropdown-container-gstr2a2bnew document-type-filter"
                  style={{ width: "40%" }}
                >
                  <SelectMenu
                    options={props.dataTypeList}
                    selectedValue={props.dataTypeFilter}
                    handleChange={(e) => props.handleDataTypeFilterChange(e)}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </>
    </>
  );
};

export default ViewFilter;
